// extracted by mini-css-extract-plugin
export default {"activityBar":"ActivityBar_activityBar__4vMOb","topTabBar":"ActivityBar_topTabBar__UlTL1"};